import { Unit } from '../enums'
import { PRICING_UNIT_LABELS } from '../locales/de/units'

import { displayUnitSymbol, PRICING_UNIT_KEYS } from './units'

/**
 * The unit picker offered on a configurator section property, a house-element
 * type, and a formula summary row.
 *
 * Everything here is derived from the `Unit` enum: this file decides which
 * units the picker offers, never how one is spelled or in what order they come.
 *
 * `FLAT` is the only exclusion — it marks a lump-sum price and has no symbol,
 * so it would render as a blank row indistinguishable from "no unit".
 *
 * `value` is the member that gets stored; `label` is the symbol the user reads.
 * Storing the member rather than the symbol is what stops a mistyped symbol
 * from becoming a new unit.
 */
export const PROPERTY_UNIT_OPTIONS = Object.values(Unit)
  .filter(unit => unit !== Unit.FLAT)
  .map(unit => ({ value: unit, label: displayUnitSymbol(unit) }))

/**
 * The units something can be priced and counted in.
 *
 * Distinct from `PROPERTY_UNIT_OPTIONS`, which offers the whole registry: a
 * measure is priced per square metre or per piece, never per decibel. `FLAT`
 * belongs here and reads as "Pauschal" — a lump sum is an answer to what a
 * position is quoted in, where on a measurement it would be none.
 */
export const PRICING_UNIT_OPTIONS = PRICING_UNIT_KEYS.map(key => ({
  value: key,
  label: PRICING_UNIT_LABELS[key],
}))
